'use client';

import { useSyncExternalStore } from 'react';

// TODO: This hook duplicates logic from @packages/shared/src/hooks/useMediaType/useMediaType.ts
// We intentionally keep it separate to avoid modifying the shared hook maintained by another team.
// If tablet breakpoint detection becomes a common need, consider extending useMediaType in shared package.

// Breakpoints from docs/workflows/responsivity.md
// md: 600px (tablet), lg: 900px (desktop)
const TABLET_MIN_BREAKPOINT = 600;
const TABLET_MAX_BREAKPOINT = 900;

const TABLET_MEDIA_QUERY = `(min-width: ${TABLET_MIN_BREAKPOINT}px) and (max-width: ${TABLET_MAX_BREAKPOINT - 1}px)`;

const getClientSnapshot = (): boolean => {
  if (typeof window === 'undefined') return false;

  return window.matchMedia(TABLET_MEDIA_QUERY).matches;
};

const subscribe = (callback: () => void) => {
  if (typeof window === 'undefined') return () => {};

  const controller = new AbortController();

  const tabletQuery = window.matchMedia(TABLET_MEDIA_QUERY);
  tabletQuery.addEventListener('change', callback, { signal: controller.signal });

  return () => controller.abort();
};

/**
 * useMediaTabletType detects if the current viewport is in tablet range (600px - 899px)
 * Similar pattern to useMediaType but specifically for tablet breakpoint detection
 * Uses matchMedia for efficient, reflow-free detection with automatic updates on resize
 * @returns boolean - true if viewport is in tablet range (isTablet), false otherwise
 */
export const useMediaTabletType = (): boolean => {
  // Server snapshot - assume not tablet (most common case)
  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
};
